/**
 * LogoBadge — uses the official Stacy Fox Aesthetics logo variants
 * extracted directly from the Branding Board PDF.
 *
 * Variants:
 *  - "primary"   → large oval logo (Stone circle bg, dark text)
 *  - "stone"     → small Stone circle (for ivory/white backgrounds)
 *  - "ivory"     → small Ivory circle (for white/stone backgrounds)
 *  - "warmblack" → small Warm-Black circle (for dark backgrounds)
 */
const VARIANTS = {
  primary:   { src: "/logos/sfa-circle.png",    ratio: 1 },
  stone:     { src: "/logos/sfa-circle.png",    ratio: 1 },
  ivory:     { src: "/logos/sfa-ivory.png",     ratio: 491 / 328 },
  warmblack: { src: "/logos/sfa-warmblack.png", ratio: 513 / 328 },
};

const SIZES = {
  xs:  56,
  sm:  76,
  md:  96,
  mdl: 116,
  lg:  140,
  xl:  220,
  hero: 360,
};

export const LogoBadge = ({
  variant = "stone",
  size = "md",
  className = "",
}) => {
  const v = VARIANTS[variant] || VARIANTS.stone;
  const h = SIZES[size] || SIZES.md;
  const w = Math.round(h * v.ratio);
  return (
    <img
      src={v.src}
      alt="Stacy Fox — Laser & Advanced Aesthetics"
      width={w}
      height={h}
      draggable={false}
      className={`select-none shrink-0 ${className}`}
      style={{ width: `${w}px`, height: `${h}px` }}
    />
  );
};

export default LogoBadge;
